<template>
  <!-- One sidebar place (MacMain, d37): 30 tall at pointer density, 44 at
       touch; a link you can Tab to (SI-21). -->
  <router-link
    :to="place.path"
    class="sb-row"
    :class="{ 'is-selected': selected }"
    :aria-current="selected ? 'page' : null"
    :style="{ '--sb-icon': selected ? 'var(--cl-accent-text-strong)' : place.iconColor || 'var(--cl-accent-text)' }"
  >
    <ClIcon class="sb-icon" :path="place.icon" :size="iconSize" />
    <span class="sb-label">{{ place.label }}</span>
    <CountPill :value="count" :badge="place.count === 'badge'" />
  </router-link>
</template>

<script>
import ClIcon from "@/components/kit/ClIcon.vue";
import CountPill from "@/components/kit/CountPill.vue";
import { shellState } from "./shellState.js";

export default {
  name: "SidebarRow",
  components: { ClIcon, CountPill },
  props: {
    place: { type: Object, required: true },
    selected: { type: Boolean, default: false },
    count: { type: Number, default: null },
  },
  computed: {
    iconSize() {
      return shellState.density === "touch" ? 22 : 16;
    },
  },
};
</script>

<style scoped>
.sb-row {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 30px;
  padding: 0 8px 0 10px;
  border-radius: 7px;
  color: var(--cl-label-85);
  text-decoration: none;
  font: 400 13px/16px var(--cl-font);
  outline: none;
}
.sb-row:focus-visible {
  box-shadow: inset 0 0 0 2px var(--cl-accent);
}
:root[data-density="pointer"] .sb-row:hover:not(.is-selected) {
  background: var(--cl-hover);
  color: var(--cl-label-85);
}
.sb-row.is-selected {
  background: var(--cl-accent-fill);
  color: var(--cl-on-fill);
}
.sb-icon {
  color: var(--sb-icon);
}
.sb-label {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:root[data-density="touch"] .sb-row {
  height: 44px;
  padding: 0 12px;
  gap: 12px;
  border-radius: 10px;
  font-size: 17px;
  line-height: 22px;
}
</style>
